import styled, { css, keyframes } from "styled-components"
import React from "react"

const animation = keyframes`
      0%, 40%, 100% { 
        height:80%;
      }  20% { 
        height:100%;
      }
  `
const Container = styled.div`
  display: flex;
  align-items: center;
  height: ${props => 25 * props.size}px;

  div {
    display: block;
    width: ${props => 3 * props.size}px;
    margin: 0 ${props => 2.5 * props.size}px;
    transform: rotateZ(45deg);
    border-radius: 500px;
    background-color: ${props => props.color || props.theme.colors.coral};
    animation: ${animation} 1.2s infinite ease-in-out;
  }
`

export const Lines = ({ size = 2, color = "#ee7f73", ...props }) => {
  return (
    <Container color={color} size={size} {...props}>
      <div />
      <div
        css={css`
          animation-delay: -1.1s !important;
        `}
      />
      <div
        css={css`
          animation-delay: -1s !important;
        `}
      />
      <div
        css={css`
          animation-delay: -0.9s !important;
        `}
      />
      <div
        css={css`
          animation-delay: -0.8s !important;
        `}
      />
    </Container>
  )
}
